export default [
  { value: "Rede", text: "Rede" },
  { value: "Cielo", text: "Cielo" },
];
